import { Model } from "appworks/model/model";
import { RealityMode } from "appworks/model/settings/settings-model";
import { CurrencyService } from "appworks/services/currency/currency-service";
import { gameiomModel } from "gameiom/model/gameiom-model";

export class AgsCurrencyService extends CurrencyService {

    public static CLEAN_FORMATTING: boolean = false;

    /**
     * Formats a number to the currency as configured
     *
     * @param value {number}
     * @param trailingDecimals {boolean}
     * @param forceCreditMode {boolean}     Specify true to format as credits or false to format as currency, regardless of current configuration
     * @return {string}
     */
    public format(value: number, trailingDecimals: boolean = true, forceCreditMode?: boolean): string {

        if (value === null) {
            value = 0;
        }

        let creditsValue = Math.floor(value / this.creditRatio);

        // Model always stores smallest unit (cents, pence etc), and currency should be displayed in pounds/dollars etc
        if (!AgsCurrencyService.CLEAN_FORMATTING) {
            value /= 100;
        }

        const format: Intl.NumberFormatOptions = {
        };

        const formatAsCredits = (this.credits || forceCreditMode === true) && forceCreditMode !== false;

        if (formatAsCredits) {
            format.style = "decimal";
            format.minimumFractionDigits = 0;
            format.maximumFractionDigits = 0;
            value = creditsValue;
        } else {
            format.style = "currency";
            format.minimumFractionDigits = 2;
            format.currency = this.currency;
            format.currencyDisplay = this.symbolDisplay;
        }

        if (AgsCurrencyService.CLEAN_FORMATTING) {
            format.style = "decimal";
        }

        const { playMode } = Model.read().settings;
        if (playMode === RealityMode.FREE) {
            format.style = "decimal";
        }

        format.useGrouping = this.useGrouping;

        let formatted = value.toLocaleString(this.locale, format);

        // (toLocaleString fix) remove CA from french - CAD currency
        if (gameiomModel.removeFromCurrencyString) {
            formatted = this.removeFromCurrency(formatted, gameiomModel.removeFromCurrencyString);
        }

        // Final safeguard against floating point errors
        formatted = this.fixFloatingPointError(formatted);

        if (!trailingDecimals) {
            formatted = formatted.replace(`${this.decimalSeparator}00`, "");
        }

        return formatted;
    }

    public fixFloatingPointError(s: string) {
        const decimalPosition = s.indexOf(this.decimalSeparator);

        if (decimalPosition > -1) {
            const firstHalf = s.slice(0, decimalPosition + 3);
            const secondHalf = s.slice(decimalPosition + 3).replace(/\d/gi, "");
            s = firstHalf + secondHalf;
        }

        return s;
    }

    protected removeFromCurrency(currency: string, removedType: string): string {
        return currency.replace(removedType, "");
    }
}
